import { FITTER_REPAIR, GIFT_COINS, SCORE, STAR_SECONDS, type GiftKind, type StarFactor } from '@accra/shared';
import type { EventBus } from '../../core/events';
import type { RunState } from '../../game/RunState';
import { addBonus } from '../scoring';

/** A star boosts the score for a while. The bigger factor wins; the timer restarts either way. */
export function collectStar(state: RunState, factor: StarFactor, events: EventBus): void {
  const active = state.star.left > 0 ? state.star.factor : 1;
  state.star = { factor: Math.max(active, factor), left: STAR_SECONDS };
  state.stats.powerUps += 1;
  events.emit('pickup:star', { factor: state.star.factor, seconds: STAR_SECONDS });
}

/** A gift box drops a handful of coins; a fitter's toolbox fixes some of the damage. */
export function collectGift(state: RunState, kind: GiftKind, events: EventBus): void {
  if (kind === 'cash') {
    state.stats.coins += GIFT_COINS;
    addBonus(state, SCORE.perCoin * GIFT_COINS);
    events.emit('pickup:gift', { kind, coins: GIFT_COINS, repaired: 0 });
    return;
  }
  const repaired = Math.min(state.bus.damage, FITTER_REPAIR);
  state.bus.damage -= repaired;
  events.emit('pickup:gift', { kind, coins: 0, repaired });
}

/** Counts the star boost down. */
export function updateStar(state: RunState, dt: number): void {
  if (state.star.left <= 0) return;
  state.star.left = Math.max(0, state.star.left - dt);
  if (state.star.left === 0) state.star.factor = 1;
}

/** Score boost from a star or Black Star ×2, whichever is bigger (they don't stack). */
export function scoreBoost(state: RunState): number {
  const star = state.star.left > 0 ? state.star.factor : 1;
  const double = state.powers.double > 0 ? SCORE.doubleFactor : 1;
  return Math.max(star, double);
}
